// These vars are available to the client code.

export const numberOfMerchants = "75,000";

// set by redesign index.tsx to ensure all subsequent visits get redirected to /app
export const LD_REDESIGN_REDIRECT = "LD_REDESIGN_REDIRECT";

// will be used to handle clientId across sessions for LD, Amplitude, Sentry
export const PROSPECT_CLIENT_ID_KEY = "PROSPECT_CLIENT_ID_KEY";

export const SENTRY_ORG_SLUG = "touchcorp-ul";
export const SENTRY_DSN =
  "https://9360890267514064baf59fd2a64ec229@sentry.io/1317393";

export const GENERIC_ERROR =
  "Something went wrong. We are investigating. Try refreshing the page.";
